import { useMutation, useQueryClient, type UseMutateFunction } from '@tanstack/react-query';
import { companyService } from '../services/company.service';
import type { CreateCompanyRequest, Company } from '../types/company.types';

export function useCreateCompany(): {
  createCompany: UseMutateFunction<Company, Error, CreateCompanyRequest>;
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  error: Error | null;
} {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (data: CreateCompanyRequest) => companyService.createCompany(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['companies'] });
    },
  });

  return {
    createCompany: mutation.mutate,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
  };
}
